<script>
/**
 * ****************************************************************************
 * @description     :   index of 管理者ファイル管理
 * @created at      :   2024/07/29
 * @created by      :   ANS376 – daonx@ans-net.jp.co
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
import MNG_System006 from '@/views/move/mng_system/MNG_System006/store';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import PopupArea from '@/views/popupSearch/popup_area/store';
import PopupOffice from '@/views/popupSearch/popup_office/store';
import Header from '@/shared/header/store';
import popupChangePass from '@/views/popupSearch/popup_change_pass/index.vue';
import MNG_Client008 from '@/views/move/mng_client/MNG_Client008/store';
/**
 * Import template
 */
import template from './template.html';
import '../style.scss';
import helpers from '@/utils/helpers';
import { password_input_rule, regexpValidateEmail } from '@/utils/constants';

/**
 * Define component chat for show page chat
 */
var MasterSearch = {
    template: template,
    components: {
        PopupArea,
        PopupOffice,
        popupChangePass
    },
    beforeCreate() {
        if (!store.hasModule('MNG_System006')) {
            store.registerModule('MNG_System006', MNG_System006);
        }
        if (!store.hasModule('PopupArea')) {
            store.registerModule('PopupArea', PopupArea);
        }
        if (!store.hasModule('PopupOffice')) {
            store.registerModule('PopupOffice', PopupOffice);
        }
        if (!store.hasModule('Header')) {
            store.registerModule('Header', Header);
        }
        if (!store.hasModule('MNG_Client008')) {
            store.registerModule('MNG_Client008', MNG_Client008);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        if (!this.$route?.query?.clear) {
            this.onInitScreen();
        }
        // this.referAreaSearch(0, this.user.department_cd);
    },
    mounted() {
        this.setHeader(this.header);
        this.search();
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.setHeader();
        this.hideModalMessage();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'MNG_System006',
            userId: '',
            mode: 0,
            errors: [],
            isPopupPassword: false,
            email_mode: false,
            password_input_rule: password_input_rule,
            tempDataFile: null,
            tempStatus: 0
        };
    },
    computed: {
        ...mapState('app', ['user']),
        ...mapState('MNG_System006', ['data', 'selectOptionKey', 'totalRows', 'listData', 'msgNoData', 'isSuccess', 'data_select']),
        header() {
            const data = {
                title: '個人設定',
                showBack: false,
                onBack: () => {
                    this.$router.go(-1);
                }
            };
            return data;
        },
        disableButton() {
            if (!this.data.user_id) {
                return true;
            }
            if (this.errors.length > 0) {
                return true;
            }
            return false;
        },
        version() {
            return process.env.VUE_APP_VERSION;
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        // ...mapMutations('menu', ['setActiveLeftMenu']),
        ...mapMutations('MNG_System006', ['clearData', 'resetDataInit', 'setPageNavigation', 'setPageNo']),
        ...mapActions('MNG_System006', ['getUserInfo', 'getAreaInfo', 'getOfficeInfo', 'store']),
        ...mapActions('MNG_Client008', ['uploadFile', 'getImage']),
        ...mapActions('PopupArea', ['searchAreaInfo']),
        ...mapActions('PopupOffice', ['searchOfficeInfo']),
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        search() {
            this.getUserInfo({
                body: {
                    user_id: this.user.user_id
                },
                callback: (response) => {
                    if (response.Data.email_address2 && response.Data.email_address2.length > 0) {
                        this.email_mode = true;
                    }
                    // this.data.image = response.Data.image;
                    // this.getImage(this.data.path_image);
                }
            });
        },
        referAreaSearch(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.department_cd = result.department_cd;
                            this.data.department_name = result.department_name;
                        } else {
                            this.data.department_cd = '';
                            this.data.department_name = '';
                        }
                        this.data.office_cd = '';
                        this.data.office_name = '';
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.department_cd = '';
                this.data.department_name = '';
                this.data.office_cd = '';
                this.data.office_name = '';
            }
        },
        getAreaName(data) {
            this.data.department_name = data;
        },
        referOfficeSearch(index, value) {
            if (value) {
                this.searchOfficeInfo({
                    department_cd: this.data.department_cd,
                    office_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.office_cd = result.office_cd;
                            this.data.office_name = result.office_name;
                        } else {
                            this.data.office_cd = '';
                            this.data.office_name = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.office_cd = '';
                this.data.office_name = '';
            }
        },
        getOfficeName(data) {
            this.data.office_name = data;
        },
        submit() {
            let errorMsg = helpers.renderMsgErr(this.errors);
            if (errorMsg != '') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: errorMsg,
                    okText: MSG_BUTTON.okText
                });
            } else {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.S016,
                    content: '登録してもよろしいですか？',
                    cancelText: 'いいえ',
                    okText: 'はい',
                    callback: (ok) => {
                        if (ok) {
                            this.store({
                                body: {
                                    ...this.data
                                },
                                callback: () => {
                                    this.showModalMessage({
                                        type: MSG_TYPE.SUCCESS,
                                        title: MSG_TITLE.S001,
                                        content: '登録しました。',
                                        okText: 'OK',
                                        callback: (ok) => {
                                            if (ok) {
                                                let userInfoStorage = JSON.parse(localStorage.getItem('userInfo'));
                                                userInfoStorage.user_name = this.data.user_name;
                                                userInfoStorage.schedule_mode = this.data.schedule;
                                                localStorage.setItem('userInfo', JSON.stringify(userInfoStorage));
                                                // change data user in state
                                                store.commit('app/setUserInfo', userInfoStorage);
                                                this.$router.go(this.$router.currentRoute);
                                            }
                                        }
                                    });
                                },
                                onErrorValidate: (errors) => {
                                    this.errors = helpers.renderError(errors, this.S9007);
                                },
                                onError: (errorMessage) => {
                                    this.showHeaderError([errorMessage ?? messages.E999]);
                                }
                            });

                            // call api save image
                            let formData = new FormData();
                            let mode = this.tempStatus;
                            if (this.tempStatus != 2) {
                                formData.append(`image_file`, this.tempDataFile);
                            }
                            formData.append(`user_id`, this.data.user_id);
                            formData.append(`mode`, mode);
                            this.uploadFile({
                                body: formData,
                                callback: () => {},
                                onErrorValidate: (errors) => {
                                    this.errors = helpers.renderError(errors, this.S9007);
                                },
                                onError: (errorMessage) => {
                                    this.showHeaderError([errorMessage ?? messages.E999]);
                                }
                            });
                        }
                    }
                });
            }
        },
        validateEmail(event) {
            const id = event.target.id;
            const string = event.target.value;
            const regexp = regexpValidateEmail;
            if (regexp.test(string) || string.trim() == '') {
                this.errors = this.errors.filter((error) => error.name !== id);
            } else {
                const existingErrorIndex = this.errors.findIndex((error) => error.name === id);
                let error = {
                    name: id,
                    message: 'メールアドレスのフォーマットが正しくありません。'
                };
                if (existingErrorIndex !== -1) {
                    this.errors.splice(existingErrorIndex, 1, error);
                } else {
                    this.errors.push(error);
                }
            }
        },
        editMail(mode) {
            if (mode == 1) {
                this.email_mode = true;
            } else {
                this.email_mode = false;
                this.data.email_address2 = '';
                let emailErrorIndex = this.errors.findIndex((error) => error.name === 'email_address2');
                if (emailErrorIndex !== -1) {
                    this.errors.splice(emailErrorIndex, 1); // Xóa phần tử tại chỉ số tìm được
                }
            }
        },
        addError(message) {
            this.errors.push(message);
        },
        removeError(fieldName) {
            this.errors = this.errors.filter((e) => e.name !== fieldName);
        },
        handleReferKana(autokana) {
            const id = autokana.elFurigana.id;
            if (autokana.furigana) {
                const furigana = autokana.furigana;
                if (id == 'kana_name') {
                    this.data.user_kana = furigana;
                }
            } else {
                let valueKana = autokana.elFurigana.value;
                if (id == 'kana_name') {
                    this.data.user_kana = valueKana;
                }
            }
            if (autokana.furigana) {
                const furigana = autokana.furigana;
                if (id == 'kana_name_alias') {
                    this.data.user_kana_alias = furigana;
                }
            } else {
                let valueKana = autokana.elFurigana.value;
                if (id == 'kana_name_alias') {
                    this.data.user_kana_alias = valueKana;
                }
            }
        },
        changePassWord() {
            this.isPopupPassword = true;
            this.$nextTick(() => {
                const enabledInputOrSelect = document.getElementById('oldPassword');
                if (enabledInputOrSelect) {
                    enabledInputOrSelect.focus();
                }
            });
        },
        getTransportationName(data) {
            this.data.superior_name = data;
        },
        closePopupChangePassword() {
            this.isPopupPassword = false;
            this.data.oldPassword = '';
            this.data.newPassword = '';
            this.data.newPasswordConfirm = '';
            this.removeError('oldPassword');
            this.removeError('newPassword');
            this.removeError('newPasswordConfirm');
        },
        close() {
            this.isPopupPassword = false;
            this.data.oldPassword = '';
            this.data.newPassword = '';
            this.data.newPasswordConfirm = '';
        },
        selectFile() {
            document.getElementById('input-file').value = '';
            document.getElementById('input-file').click();
        },
        changeFile(e) {
            const dataFile = e.target.files[0];
            const imagePreview = document.querySelector('.imagePreview img');
            if (helpers.checkOverMaxFileSize(dataFile)) {
                document.getElementById('input-file').value = '';
                return;
            }
            if (dataFile && dataFile.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    imagePreview.src = e.target.result;
                    imagePreview.style.display = 'block';
                };
                reader.readAsDataURL(dataFile);
                // save temp data
                this.tempDataFile = dataFile;
                this.tempStatus = 1;
                this.data.path_image = '#';
            } else {
                imagePreview.src = '#';
                imagePreview.style.display = 'none';
                this.tempStatus = 0;
                this.data.path_image = '';
            }
        },
        deleteFile() {
            const imagePreview = document.querySelector('.imagePreview img');
            imagePreview.src = '#';
            imagePreview.style.display = 'none';
            this.tempStatus = 2;
            this.data.path_image = '';
        },
        renderPath(imageName) {
            if (imageName == null) {
                const imagePreview = document.querySelector('.imagePreview img');
                imagePreview.src = '#';
                imagePreview.style.display = 'none';
                return;
            }
            return helpers.renderPath(imageName);
        },
        referWidget1(index, value) {
            if (value == '') {
                this.data.widget_1_name = '';
            }
        },
        referWidget2(index, value) {
            if (value == '') {
                this.data.widget_2_name = '';
            }
        },
        referWidget3(index, value) {
            if (value == '') {
                this.data.widget_3_name = '';
            }
        },
        referWidget4(index, value) {
            if (value == '') {
                this.data.widget_4_name = '';
            }
        },
        referWidget5(index, value) {
            if (value == '') {
                this.data.widget_5_name = '';
            }
        },
        referWidget6(index, value) {
            if (value == '') {
                this.data.widget_6_name = '';
            }
        }
    }
};
export default MasterSearch;
</script>
